export const ALGOLIA_APP_ID = "V9YD7AWBOS";
export const ALGOLIA_API_PUBLIC_KEY = "5cb206cb0658a9daff865eef79de4bc4";
export const ALGOLIA_INDEX_NAME = "homepage";
